import cuestionarioService from '../services/resultado.js';

export const useResultado = () => {

    const getResultadoByCuestionario = (idCuestionario, usuario) => cuestionarioService.getResultadoByCuestionario(idCuestionario, usuario);

    return { getResultadoByCuestionario };
}